module.exports = __webpack_public_path__ + "static/media/lunch.30c1a593.jpg";